import Parse from "../api/ApiConfig";

export const userIsLoggedIn = () => {
	const isLoggedIn = sessionStorage.getItem("isLoggedIn");
	const localUser = JSON.parse(localStorage.getItem("Parse/FortCore/currentUser"));
	const currentUser = Parse.User.current();
	// Check if the user is the same as the one in the local storage
	const isSameUser = currentUser && localUser ? currentUser.id === localUser.objectId : false;

	// console.log("localUser", [localUser?.objectId, localUser?.email]);
	// console.log("currentUser", [currentUser?.id, currentUser?.get("email")]);

	return isLoggedIn !== null && currentUser !== null && isSameUser;
};

export const getCurrentUserInfo = () => {
	const currentUser = Parse.User.current();
	return { objectId: currentUser.id, ...currentUser.attributes };
};

const getServiceRights = (role) => {
	// Role(Department): "Risk & Compliance", "Finance",
	if (role === "Risk & Compliance") {
		return ["lease", "apprenticeship", "travel-advance"];
	} else if (role === "Finance") {
		return ["lease", "apprenticeship", "travel-advance"];
	} else if (role === "Catalogue") {
		return ["education", "products"];
	} else if (role === "Logistics") {
		return ["logistics"];
	} else if (role === "AF Account Manager") {
		return ["account"];
	}
	// Super Admin
	else if (role === "Super Admin") {
		return "all";
	} else {
		return [];
	}
};

export const canAccessService = (services) => {
	const currentUser = Parse.User.current();
	const serviceRights = getServiceRights(currentUser.get("role"));
	// Check if the user has access to the services
	if (serviceRights === "all") {
		return true;
	} else {
		return serviceRights?.length ? services.some((service) => serviceRights.includes(service)) : false;
	}
};

export const canPerformAction = (action, service) => {
	// action: "recommend", "approve", "reject", "edit", "delete",
	const currentUser = Parse.User.current();
	const privileges = currentUser.get("privileges");
	const serviceRights = getServiceRights(currentUser.get("role"));

	// Check if the user has access to the service
	if (serviceRights.includes(service) || serviceRights === "all") {
		const canRecommendPrivileges = ["admin", "firstLineApproval", "secondLineApproval", "finalApproval"];
		const canApprovePrivileges = ["firstLineApproval", "secondLineApproval", "finalApproval"];

		if (action === "recommend") {
			return canRecommendPrivileges.includes(privileges) ? true : false;
		} else if (action === "approve" || action === "reject") {
			return canApprovePrivileges.includes(privileges) ? true : false;
		} else if (action === "edit") {
			return privileges === "Super Administrator" ? true : false;
		} else if (action === "delete") {
			return privileges === "Super Administrator" ? true : false;
		}
	} else return false;
};

export const canCreateAsset = () => {
	const currentUser = Parse.User.current();
	const role = currentUser.get("role");
	return role === "Risk & Compliance" || role === "Super Admin" ? true : false;
};

export const checkForFinance = () => {
	const currentUser = Parse.User.current();
	const privileges = currentUser.get("privileges");
	const role = currentUser.get("role");

	if (privileges === "Super Administrator") {
		return true;
	}
	if (privileges === "firstLineApproval" && role === "Finance") {
		return true;
	} else {
		return false;
	}
};

export const logoutUser = () => {
	// Parse.User.logOut().then(() => {
	setTimeout(() => {
		localStorage.clear();
		sessionStorage.clear();
		window.location.href = "/login";
		// navigate("/login", { replace: true });
	}, 200);
	// });
};
